export default "__VITE_ASSET__8c3dd1f8__"